module.exports = __webpack_public_path__ + "media/images/banner-help-center-fb2547cd9786bf58ec35bcba720a6515.jpg";